import React, { useEffect, useState } from "react";

import { ActionItem } from "../../models/SKArtifact";
import ActionPopup from "../../components/ActionPopup";

import ContainerNavigation from "../../components/ContainerNavigation";
import Loader from "../../components/Loader";
import dayjs from "dayjs";
import { capitalizeFirstLetter } from "../../utils/stringFunctions";
import { deleteInvite, fetchAdminMembers, fetchInvitedMembers, fetchMembersByInvitee } from "../../api/invite/memberServices";
import { UserRole, useAuth } from "../../context/AuthContext";
import { MemberInvite } from "../../models/ChannelMember";
import { format } from "date-fns";
import AddMember from "./AddMember";
import { Link } from "react-router-dom";
import APILoader from "../../components/APILoader";

interface ActionOnItem {
  itemid: string;
  action: ActionItem;
}

enum MemberType {
  member = "mebmer",
  invited = "invited",
}
const ListMembers = () => {
  // const [activePopupId, setActivePopupId] = useState<number | null>(null);
  const [invites, setInvites] = useState<MemberInvite[] | null>([]);
  const [loading, setLoading] = useState(false);

  const [showUserId, setShowUserId] = useState<string | undefined>(undefined);
  const [addUser, setAddUser] = useState(false);
  const [userType, setUserType] = useState(MemberType.member);

  const auth = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      try {
        //context.userRoles.some(item => allowedRoles.includes(item))
        setInvites([]);
        if (auth?.currentUser?.uid && auth?.userRoles?.some(item => [UserRole.BrandAdmin, UserRole.CreatorAdmin].includes(item))) {
          if (userType === MemberType.invited) {
            const invites = await fetchMembersByInvitee(auth.currentUser?.uid, "pending", 20);
            setInvites(invites);
          } else {
            const invites = await fetchMembersByInvitee(auth.currentUser?.uid, "accepted", 20);
            setInvites(invites);
          }
        }
        //("status", operator, value, 20);
        if (auth?.userRoles?.some(item => [UserRole.SkarvoAdmin].includes(item))) {
          if (userType === MemberType.invited) {
            const invites = await fetchAdminMembers(20, "pending");
            setInvites(invites);
          } else {
            const invites = await fetchAdminMembers(20, "accepted");
            setInvites(invites);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [userType]);

  const updateStatus = async (inviteId: string, actionItem: ActionItem) => {
    switch (actionItem) {
      case ActionItem.delete:
        await deleteInvite(inviteId);
        setInvites(prevItems => prevItems!.filter(item => item.id !== inviteId));
        break;
      case ActionItem.edit:
        setShowUserId(inviteId);
        break;
    }
  };

  return (
    <div className="flex-1 bg-white">
      <div className="flex flex-col flex-1 ">
        <ContainerNavigation
          backArrow={false}
          title={"Team Members"}
          buttonTitle={"Add"}
          subtitle={"Channel"}
          enableLink={true}
          onBack={() => {}}
          onFilter={() => {}}
          onNext={() => {
            setAddUser(true);
          }}
        />
        {(addUser || showUserId) && (
          <AddMember
            invitationId={showUserId}
            onClose={() => {
              setShowUserId(undefined);
              setAddUser(false);
            }}
          />
        )}

        <div className="flex flex-row flex-1 gap-2 px-3">
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setUserType(MemberType.member);
            }}
            className={
              (userType === MemberType.member ? " border-black " : " border-white ") + "border-b-2 text-lg font flex items-center dark:text-black"
            }
          >
            Members
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setUserType(MemberType.invited);
            }}
            className={
              (userType === MemberType.invited ? " border-black " : " border-white ") + "border-b-2 text-lg flex items-center mx-2 dark:text-black"
            }
          >
            Invited
          </Link>
        </div>
        <div className="flex flex-col flex-1 overflow-x-auto">
          <div id="xxx" className="flex flex-col p-2 mb-[60px]">
            <div key="header" className="hidden p-2 px-2 bg-white rounded md:block">
              <div className="md:items-center md:grid md:grid-cols-6 md:gap-4 w-[800px]">
                <div className="col-span-1 text-xl font-bold md:text-base">Action</div>
                <div className="col-span-1 text-xl font-bold md:text-base">Name</div>
                <div className="col-span-1 text-xl font-bold md:text-base">Email</div>
                <div className="col-span-1 text-xl font-bold md:text-base">Role</div>
                <div className="col-span-1 text-xl font-bold md:text-base">Status</div>
                <div className="col-span-1 text-xl font-bold md:text-base">Updated</div>
              </div>
            </div>
            <div className="hidden thinseparator md:block"></div>
            {/* {loading ? <Loader /> : <></>} */}
            <APILoader loading={loading} />

            {invites?.map(content => {
              // console.log("key", content.id);
              return (
                <div key={content.id}>
                  <div className="relative p-2 px-2 mb-3 bg-white border-[1px] border-skseparatorgray md:border-0 rounded-xl md:mb-0 md:rounded-none">
                    <div className="md:items-center md:grid md:grid-cols-6 md:w-[800px]">
                      <ActionPopup
                        className="m-2 md:col-span-1"
                        getValues={() => {
                          return [ActionItem.edit, ActionItem.delete];
                        }}
                        onSelect={actionItem => {
                          if (actionItem === ActionItem.delete) {
                            //show remove dialog
                          } else {
                            //Show edit view
                          }
                          //   setActionOnItem({ itemid: content.id!, action: actionItem });
                          updateStatus(content.id!, actionItem as ActionItem);
                        }}
                        align="left"
                      />
                      <div className="mt-4 text-xs text-gray-500 md:hidden md:mt-0">Name</div>
                      <div
                        className="col-span-1 capitalize md:text-base hover:cursor-pointer hover:text-skgreen"
                        onClick={() => {
                          setShowUserId(content.id);
                        }}
                      >
                        {content.name}
                      </div>

                      <div className="mt-4 text-xs text-gray-500 md:hidden md:mt-0">Email</div>
                      <div className="col-span-1 truncate md:text-base text-ellipsis">{content.email}</div>
                      <div className="grid grid-cols-2 mt-4 md:col-span-2 md:mt-0">
                        <div className="flex flex-col md:col-span-1">
                          <div className="text-xs text-gray-500 md:hidden">Status</div>
                          <div className="flex items-center capitalize md:text-black md:text-base">{capitalizeFirstLetter(content.status)}</div>
                        </div>
                        <div className="flex flex-col md:col-span-1">
                          <div className="text-xs text-gray-500 md:hidden">Role</div>
                          <div className="flex items-center capitalize md:text-black md:text-base">{content.role}</div>
                        </div>
                      </div>

                      <div className="hidden col-span-1 text-xl md:text-base md:block">{format(content.createdDate.toDate(), "MMM, dd yyyy")}</div>
                    </div>
                  </div>
                  <div className="thinseparator"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListMembers;
